var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                      '<div class="games-table-header games-table-title">'+
                          'EVENTS'+
                      '</div>'+
                      '<div class="games-table-header games-table-tree">'+
                          '<ul>'+
                              '<li>1-1</li> '+
                              '<li>1-X</li> '+
                              '<li>1-2</li>'+
                          '</ul>'+
                      '</div> '+
                      '<div class="games-table-header games-table-tree">'+
                          '<ul>'+
                              ' <li>X-1</li> '+
                              '<li>X-X</li> '+
                              '<li>X-2</li>'+
                          '</ul>'+
                      '</div> '+
                      '<div class="games-table-header games-table-tree">'+
                          '<ul>'+
                              '<li>2-1</li> '+
                              '<li>2-X</li> '+
                              '<li>2-2</li>'+
                          '</ul>'+
                      '</div>'+
                  '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div>'+
                        '<div class="games-table games-table-tree">'+
                             '<ul>'+
                                 '<li data-betType="1-1" data-betCode="211" class="bet-choose" data-odd="'+quotes.HTFT11+'">'+globalFunctions.checkQuotes(quotes.HTFT11)+'</li> '+
                                 '<li data-betType="1-X" data-betCode="210" class="bet-choose" data-odd="'+quotes.HTFT1X+'">'+globalFunctions.checkQuotes(quotes.HTFT1X)+'</li> '+
                                 '<li data-betType="1-2" data-betCode="212" class="bet-choose" data-odd="'+quotes.HTFT12+'">'+globalFunctions.checkQuotes(quotes.HTFT12)+'</li>'+
                             '</ul>'+
                         '</div> '+
                         '<div class="games-table games-table-tree">'+
                             '<ul>'+
                                 '<li data-betType="X-1" data-betCode="201" class="bet-choose" data-odd="'+quotes.HTFTX1+'">'+globalFunctions.checkQuotes(quotes.HTFTX1)+'</li> '+
                                 '<li data-betType="X-X" data-betCode="200" class="bet-choose" data-odd="'+quotes.HTFTXX+'">'+globalFunctions.checkQuotes(quotes.HTFTXX)+'</li> '+
                                 '<li data-betType="X-2" data-betCode="202" class="bet-choose" data-odd="'+quotes.HTFTX2+'">'+globalFunctions.checkQuotes(quotes.HTFTX2)+'</li>'+
                             '</ul>'+
                         '</div> '+
                         '<div class="games-table games-table-tree">'+
                             '<ul>'+
                                  '<li data-betType="2-1" data-betCode="221" class="bet-choose" data-odd="'+quotes.HTFT21+'">'+globalFunctions.checkQuotes(quotes.HTFT21)+'</li> '+
                                 '<li data-betType="2-X" data-betCode="220" class="bet-choose" data-odd="'+quotes.HTFT2X+'">'+globalFunctions.checkQuotes(quotes.HTFT2X)+'</li> '+
                                 '<li data-betType="2-2" data-betCode="222" class="bet-choose" data-odd="'+quotes.HTFT22+'">'+globalFunctions.checkQuotes(quotes.HTFT22)+'</li>'+
                             '</ul>'+
                         '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/ht_ft.js
// module id = 2005
// module chunks = 4